import { Button } from "@chakra-ui/react"
import { Link } from "react-router-dom";

const LinkButton = ({ buttonText, buttonUrl, colorScheme = "orange", variant = "outline" }) => {
    return (
        <Link to={buttonUrl}>
            <Button
                colorScheme={colorScheme}
                variant={variant}
                type='button'
                w={{ base: "100%", sm: "auto" }}
                size={{ base: "sm", md: "sm" }}
            >
                {buttonText}
            </Button>
        </Link>
    )
};

export default LinkButton;